import { PercentileLevel } from '@talentmesh/utils';
import React, { useMemo } from 'react';
import { PercentileScoreDTO as PSD, ScoreDTO } from '@/Models/CandidateOverview';
import { TalentScore } from '@/Models/TalentScore';
import ScoreCell from '@/Components/Table/ScoreCell';

interface ScoreCellProps {
    scoring: TalentScore | PSD | ScoreDTO | null;
}

const isTalentScore = (value: unknown): value is TalentScore => typeof (value as TalentScore)?.talentScore === 'number';
const isPercentile = (value: unknown): value is PSD => typeof (value as PSD)?.percentileScore === 'number';
const isScore = (value: unknown): value is ScoreDTO => typeof (value as ScoreDTO)?.score === 'number';
type StandardScoring = [number?, PercentileLevel?];

const TestScoreCell = ({ scoring }: ScoreCellProps) => {
    const [score, level] = useMemo<StandardScoring>(() => {
        if (isTalentScore(scoring)) {
            return [scoring.talentScore, scoring.scoreLevel];
        } else if (isPercentile(scoring)) {
            return [scoring.percentileScore, scoring.percentileLevel];
        } else if (isScore(scoring)) {
            return [scoring.score, scoring.scoreLevel];
        }

        return [undefined, undefined];
    }, [scoring]);

    return <ScoreCell level={level} score={score} />;
};

export default TestScoreCell;
